meedy.factory('meedy.calendarModel', ['$rootScope', 'applicationModel','meedy.baseModel', 'meedy.calendarService', 'meedy.moonService', 'meedy.namedaysService',
    function($rootScope, applicationModel, baseModel, calendarService, moonService, namedaysService) {

        function CalendarModel() {

            this.getMoonPhase = function(date) {
                moonService.getMoonPhase(date).then(
                    function (moonPhase) {
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.GET_MOON_PHASE.SUCCESS, moonPhase);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.GET_MOON_PHASE.ERROR, error);
                    }
                )
            };

            this.getNameDays = function(date) {
                namedaysService.getNamedays(date).then(
                    function (namedays) {
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.GET_NAMEDAYS.SUCCESS, namedays);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.GET_NAMEDAYS.ERROR, error);
                    }
                )
            };

            this.getCalendarDataForResource = function (idResource, startDate, calendarType) {
                calendarService.getCalendarDataForResource(idResource, startDate, calendarType).then(
                    function (calendarData) {
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.GET_CALENDAR_DATA_FOR_RESOURCE.SUCCESS, calendarData);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.GET_CALENDAR_DATA_FOR_RESOURCE.ERROR, error);
                    }
                )
            };

            this.getCalendarData = function (requestParams) {
                calendarService.getCalendarData(requestParams).then(
                    function (calendarData) {
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.GET_CALENDAR_DATA.SUCCESS, calendarData);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.GET_CALENDAR_DATA.ERROR, error);
                    }
                )
            };

            this.getDailyPlanToken = function(data) {
                calendarService.getDailyPlanToken(data).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.GET_DAILY_PLAN_TOKEN.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.GET_DAILY_PLAN_TOKEN.ERROR, error);
                    }
                )
            };


            this.downloadDailyPlan = function(token) {
                calendarService.downloadDailyPlan(token).then(
                    function (dataPage) {
                        self.fileType = undefined;
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.DOWNLOAD_DAILY_PLAN.SUCCESS, dataPage);
                    },
                    function(error) {
                        self.fileType = undefined;
                        $rootScope.$broadcast(Event.MEEDY.CALENDAR.DOWNLOAD_DAILY_PLAN.ERROR, error);
                    }
                )
            };

            this.searchMeedyPatients = function (requestParams) {
                return calendarService.searchMeedyPatients(requestParams);
            };
        }

        return new CalendarModel();
    }
]);
